module.exports = __webpack_public_path__ + "img/img_index_banner_x1@2x.402fee8c.png";